export const REVIEWS_FETCH_PER_PAGE = 10;
// export const MAX_REVIEWS_TO_SHOW = 30;
export const MAX_REVIEWS_TO_SHOW = 500;
